import React from "react";
import { BarChart, Bar, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { FilterYearType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExceltIndications } from "../../functions/Report.ExportIndications";
import { formatDataIndications } from "../../utils/Report.Format";
import {
  BARCHART,
  SCREENIPAD,
  STYLEHEAD,
  STYLEBODY,
  FLEXDROPDOWN,
} from "../../../../utils/useStyle";

const ReportIndications = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = React.useState({
    label: "-",
    value: "NONE",
  });

  const [data, setData] = React.useState({
    tpn: 0,
    prolonged_iv_meds: 0,
    chemotherapy: 0,
    vasopressor: 0,
    frequent_blood_sampling: 0,
    stem_cell_collection_plasma_exchange: 0,
    stem_cell_transplantation: 0,
    other_indication: 0,
  });

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getIndicationsReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching indications report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const listTable = [
    { name: "TPN", count: data?.tpn },
    { name: "Prolonged IV meds", count: data?.prolonged_iv_meds },
    { name: "Chemotherapy", count: data?.chemotherapy },
    { name: "Vasopressor", count: data?.vasopressor },
    { name: "เจาะเลือดบ่อย", count: data?.frequent_blood_sampling },
    {
      name: "Stem cell/ Plasma Exc.",
      count: data?.stem_cell_collection_plasma_exchange,
    },
    { name: "Stem cell Tx", count: data?.stem_cell_transplantation },
    { name: "Other", count: data?.other_indication },
  ];

  const total =
    data?.tpn +
    data?.prolonged_iv_meds +
    data?.chemotherapy +
    data?.vasopressor +
    data?.frequent_blood_sampling +
    data?.stem_cell_collection_plasma_exchange +
    data?.stem_cell_transplantation +
    data?.other_indication;

  const tpnPercentage = ((data?.tpn / total) * 100).toFixed(1) + "%";
  const prolonged_iv_medsPercentage =
    ((data?.prolonged_iv_meds / total) * 100).toFixed(1) + "%";
  const chemotherapyPercentage =
    ((data?.chemotherapy / total) * 100).toFixed(1) + "%";
  const vasopressorPercentage =
    ((data?.vasopressor / total) * 100).toFixed(1) + "%";
  const frequent_blood_samplingPercentage =
    ((data?.frequent_blood_sampling / total) * 100).toFixed(1) + "%";
  const stem_cell_collection_plasma_exchangePercentage =
    ((data?.stem_cell_collection_plasma_exchange / total) * 100).toFixed(1) +
    "%";
  const stem_cell_transplantationPercentage =
    ((data?.stem_cell_transplantation / total) * 100).toFixed(1) + "%";
  const other_indicationPercentage =
    ((data?.other_indication / total) * 100).toFixed(1) + "%";

  return (
    <div>
      _____________________________________________________________________________________
      <div className={``}>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <div className={STYLEHEAD}>
                รายงานข้อบ่งชี้การใส่สาย
                <div className={STYLEBODY}>
                  ของปี "{year.label}" ประเภทสาย "{type.label}"
                </div>
              </div>
              <div className={FLEXDROPDOWN}>
                <FilterYearType
                  year={year}
                  setYear={setYear}
                  type={type}
                  setType={setType}
                />
                <ButtonExcel
                  onClick={() => {
                    ExceltIndications(
                      formatDataIndications(data),
                      year,
                      type,
                      setLoading
                    );
                  }}
                  loading={loading}
                />
              </div>
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listTable}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <YAxis />
                <Tooltip />
                <Bar label={true} dataKey="count" fill="#FFCC66" />
              </BarChart>
            </div>
            <div className="grid grid-cols-8 mx-16 my-6 text-sm">
              <div className=" -rotate-45 transform-gpu text-center">
                TPN <br /> {tpnPercentage}
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Prolonged IV meds <br /> {prolonged_iv_medsPercentage}
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Chemotherapy <br /> {chemotherapyPercentage}
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Vasopressor <br /> {vasopressorPercentage}
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                เจาะเลือดบ่อย <br /> {frequent_blood_samplingPercentage}
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Stem cell/ Plasma Exc. <br />{" "}
                {stem_cell_collection_plasma_exchangePercentage}
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Stem cell Tx <br /> {stem_cell_transplantationPercentage}
              </div>
              <div className=" -rotate-45 transform-gpu text-center">
                Other <br /> {other_indicationPercentage}{" "}
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default ReportIndications;
